module.exports = __webpack_public_path__ + "img/to_sudoku_kr.33b0df53.png";